// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Op-z","tooltipWrapper":"Pp-z","icon":"Qp-z","tooltip":"Rp-z","content":"Sp-z"};